export default [
  {
    name: 'Lilly',
    id: 'lilly',
    enabled: true,
    match: /@(lilly|elanco|imclone|network.lilly).com$/
  },
  {
    name: '3M',
    id: 'mmm',
    enabled: true,
    match: /@mmm.com$/
  },
  {
    name: 'Google',
    id: 'google',
    enabled: true,
    match: /@focusvision.com$/
  }
].filter(provider => provider.enabled)



// WEBPACK FOOTER //
// ./src/config/ssoProviders.js